/* eslint-disable arrow-parens */
import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Select, Button } from 'antd'
import styles from './styles.css'

const { Option } = Select

const inputStyles = {
  display: 'block',
  width: 380,
}

const selectStyles = {
  width: '100%',
  maxWidth: 380,
}

const ApptTypeSelection = ({
  appointmentTypes,
  onApptTypeFilterChange,
  apptTypefilterOptions,
  onAddNewOptionClick,
  onDeleteOptionClick,
}) => {
  const apptTypeOptions = appointmentTypes.map(apptType => {
    const { id, code, description } = apptType
    return (
      <Option key={id}>{`${code ? `${code}:` : ''} ${description}`}</Option>
    )
  })

  const ButtonHeader = `To set up a custom filter for different appointment types, enter a label
        in the first field then select the appointment types associated with it.
        For best results the button label should be short (eg. "Adult" or "Ortho Appointments")
        and no one word should be longer than 18 characters.`

  return (
    <div className={styles.apptFilterWrapper}>
      <p style={{ maxWidth: 1280 }}>{ButtonHeader}</p>
      <div className={styles.apptFilterContainer}>
        {apptTypefilterOptions.map((item, i) => {
          const buttonProps = item.button
          const apptTypeArr = item.apptTypes
          const firstOption = i === 0
          return (
            <div className={styles.apptFilterCol} key={item.id}>
              {!firstOption && (
                <Button
                  className={styles.apptFilterDeleteBtn}
                  icon="close"
                  onClick={() => onDeleteOptionClick(i)}
                />
              )}
              <Form.Item label={buttonProps.label} key={item.id}>
                <Input
                  style={inputStyles}
                  name={item}
                  onChange={e => onApptTypeFilterChange(e, i, 'input')}
                  placeholder={buttonProps.placeholder}
                  value={buttonProps.value}
                />
                <Select
                  style={selectStyles}
                  mode="multiple"
                  placeholder="Choose Appointment Types"
                  value={apptTypeArr}
                  onSelect={e => onApptTypeFilterChange(e, i, 'select')}
                  onDeselect={e => onApptTypeFilterChange(e, i, 'deselect')}
                >
                  {apptTypeOptions}
                </Select>
              </Form.Item>
            </div>
          )
        })}
      </div>
      <Button
        onClick={onAddNewOptionClick}
        disabled={apptTypefilterOptions.length > 2}
      >
        Add Filter Option
      </Button>
    </div>
  )
}

ApptTypeSelection.propTypes = {
  appointmentTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onApptTypeFilterChange: PropTypes.func.isRequired,
  onAddNewOptionClick: PropTypes.func.isRequired,
  onDeleteOptionClick: PropTypes.func.isRequired,
  apptTypefilterOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ApptTypeSelection



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/ApptTypeSelection.js